import { render, staticRenderFns } from "./BackofficeInstrumental.vue?vue&type=template&id=b4ef0948"
import script from "./BackofficeInstrumental.vue?vue&type=script&lang=ts"
export * from "./BackofficeInstrumental.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports